import { JobSeekerProfileMonthType, JobSeekerProfileResumeType } from '__generated__/graphql';
export const getDefaultContactInfo = (jobSeekerProfile) => {
    return jobSeekerProfile?.profile?.defaultInfo?.contactInformation;
};
export const getFirstIndeedResume = (jobSeekerProfile) => {
    return jobSeekerProfile?.profile?.resume?.find((resume) => resume.resumeType === JobSeekerProfileResumeType.IndeedResume);
};
export const getProfileField = (indeedResume, resumeField, defaultContactInfoField) => {
    return indeedResume ? resumeField : defaultContactInfoField;
};
export const convertToJobSeekerProfileMonth = (month) => {
    switch (month) {
        case '1':
            return JobSeekerProfileMonthType.January;
        case '2':
            return JobSeekerProfileMonthType.February;
        case '3':
            return JobSeekerProfileMonthType.March;
        case '4':
            return JobSeekerProfileMonthType.April;
        case '5':
            return JobSeekerProfileMonthType.May;
        case '6':
            return JobSeekerProfileMonthType.June;
        case '7':
            return JobSeekerProfileMonthType.July;
        case '8':
            return JobSeekerProfileMonthType.August;
        case '9':
            return JobSeekerProfileMonthType.September;
        case '10':
            return JobSeekerProfileMonthType.October;
        case '11':
            return JobSeekerProfileMonthType.November;
        case '12':
            return JobSeekerProfileMonthType.December;
    }
    return JobSeekerProfileMonthType.NotSpecified;
};
export const convertToStringMonth = (month) => {
    if (!month) {
        return '';
    }
    switch (month) {
        case JobSeekerProfileMonthType.NotSpecified:
            return '';
        case JobSeekerProfileMonthType.January:
            return '1';
        case JobSeekerProfileMonthType.February:
            return '2';
        case JobSeekerProfileMonthType.March:
            return '3';
        case JobSeekerProfileMonthType.April:
            return '4';
        case JobSeekerProfileMonthType.May:
            return '5';
        case JobSeekerProfileMonthType.June:
            return '6';
        case JobSeekerProfileMonthType.July:
            return '7';
        case JobSeekerProfileMonthType.August:
            return '8';
        case JobSeekerProfileMonthType.September:
            return '9';
        case JobSeekerProfileMonthType.October:
            return '10';
        case JobSeekerProfileMonthType.November:
            return '11';
        case JobSeekerProfileMonthType.December:
            return '12';
    }
};
export const convertToStructuredDate = (datestr) => {
    const d = new Date(datestr);
    if (isNaN(d.getTime())) {
        return {
            year: '1990',
            month: '1',
            day: '1'
        };
    }
    // ISO 8601 date-only strings (e.g. '2020-01-01') are parsed as UTC
    // midnight. Using local-timezone getters (getFullYear/getMonth/getDate)
    // would shift the calendar date for anyone running west of UTC (the test
    // passed in JST but failed on machines west of UTC). Use UTC getters so
    // the returned year/month/day match the string as written regardless of
    // the host machine's timezone.
    return {
        year: d.getUTCFullYear().toString(),
        month: (d.getUTCMonth() + 1).toString(),
        day: d.getUTCDate().toString()
    };
};
export const convertToDateStr = (sdate) => {
    const year = sdate.year.padStart(4, '0');
    const month = sdate.month.padStart(2, '0');
    const day = (sdate.day || '1').padStart(2, '0');
    return `${year}-${month}-${day}`;
};
const isValidMonth = (month) => {
    if (!month) {
        return false;
    }
    return month !== JobSeekerProfileMonthType.NotSpecified;
};
export const isValidDate = (date) => {
    return date?.year && isValidMonth(date?.month);
};
export const isValidDateRange = (dateRange) => {
    const isValidFromDate = isValidDate(dateRange?.fromDate);
    const isValidToDate = isValidDate(dateRange?.toDate);
    return isValidFromDate && (isValidToDate || dateRange?.isCurrent);
};
